export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const FETCH_ALL = 'FETCH_ALL';
export const FETCH_MINI = 'FETCH_MINI';
export const FETCH_FULL = 'FETCH_FULL';
export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';